import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { formatNumber } from '@utils/utils';

interface ComponentProps {
  loaded: number;
  total: number;
  loadingMore: boolean;
  /** The cap stopped the list short of the result. */
  capped: boolean;
  /** Row count at which the API stops counting; at or above it the total renders as "10 000+". */
  totalCapAt?: number;
}

/** Under an infinitely scrolled table, where the paginator would be: how much of the result is loaded. */
const ScrollFooter: React.FC<ComponentProps> = ({ loaded, total, loadingMore, capped, totalCapAt }) => {
  const { tr } = useTranslationLgs();
  const totalCapped = totalCapAt !== undefined && total >= totalCapAt;
  const totalText = `${formatNumber(totalCapped ? totalCapAt : total || 0, 0)}${totalCapped ? '+' : ''}`;
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 px-2 py-2 text-[11.5px] text-content-secondary" data-testid="table-scroll-footer">
      <span>
        {tr('RingilDataTable.scrollShown', 'Showing {{loaded}} of {{total}} results', { loaded: formatNumber(loaded, 0), total: totalText })}
        {loadingMore && <i className="pi pi-spin pi-spinner ml-2 text-content-brand" aria-label={tr('generic.loading', 'Loading')} />}
      </span>
      {capped && (
        <span className="text-content-primary">
          {tr('RingilDataTable.scrollCapped', 'Only the first {{loaded}} are shown. Narrow the filters to see the rest.', { loaded: formatNumber(loaded, 0) })}
        </span>
      )}
    </div>
  );
};

export default ScrollFooter;
